import { render, staticRenderFns } from "./albumList.vue?vue&type=template&id=32d822cc&scoped=true&"
import script from "./albumList.vue?vue&type=script&lang=js&"
export * from "./albumList.vue?vue&type=script&lang=js&"
import style0 from "./albumList.vue?vue&type=style&index=0&id=32d822cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d822cc",
  null
  
)

export default component.exports